import { Pipe, type PipeTransform } from '@angular/core';
import { InvitationGroup } from '@markant-platform/authorizer/model';

@Pipe({
  name: 'isGroupSelected',
  standalone: true,
})
export class IsSelectedGroupPipe implements PipeTransform {
  transform(invitationGroups: InvitationGroup[], invitationGroupId: string): boolean {
    return invitationGroups.some(({ id }) => invitationGroupId === id);
  }
}
